import { Injectable } from '@angular/core';
import { Cordova, IonicNativePlugin, Plugin } from '@ionic-native/core';

@Plugin({
  pluginName: 'ImmersePlugin',
  plugin: 'cordova-plugin-Immerse',
  pluginRef: 'ImmersePlugin',
  repo: 'https://github.com/squallliu/cordova-plugin-Immerse',
  platforms: ['Android']
})

export class Immerse extends IonicNativePlugin {
  @Cordova({
    sync: true
  })
  setDarkMode(_enable: boolean): void { }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
